import { useState } from 'react';

import { StorageKey } from '../constants';

type UseSummaryToggle = {
  value: boolean;
  getShowSummary: () => boolean;
  toggleSummary: () => void;
};

const getStorage = () => {
  return localStorage.getItem(StorageKey.ShowSummary) !== 'false';
};

const setStorage = (value: boolean) => {
  localStorage.setItem(StorageKey.ShowSummary, value.toString());
};

export const useSummaryToggle = (): UseSummaryToggle => {
  const [value, setValue] = useState(getStorage());

  const toggleSummary = () => {
    const prev = value;
    setValue(!prev);
    setStorage(!prev);
  };

  return {
    value,
    getShowSummary: getStorage,
    toggleSummary,
  };
};
